import { action } from 'typesafe-actions';
import { Tracking, TrackingTypes, Pagination, Filter, FilterTracking } from './types';

export const loadRequest = (
  filtro: FilterTracking | any,
  inscricao: number[],
  cd: number,
  pagination?: Pagination
) => action(TrackingTypes.LOAD_TRACKING_REQUEST, { filtro, inscricao, cd, pagination });

export const loadSuccess = (data: Tracking[], pagination: Pagination) =>
  action(TrackingTypes.LOAD_TRACKING_SUCCESS, { data, pagination });

export const loadFailure = () => action(TrackingTypes.LOAD_TRACKING_FAILURE);

export const filterTracking = (filter: Filter) => action(TrackingTypes.FILTER_TRACKING, { filter });

export const clearFilterTracking = () => action(TrackingTypes.CLEAR_TRACKING);
